import { createReducer } from '@reduxjs/toolkit';
import {
	submitFundingAction,
	generatePrivyFundingAction,
	successFundingAction,
	failedFundingAction,
	resetFundingStateAction,
	getLoanAgreementDocumentAction,
	setLoanAgreementDocumentAction,
	resetLoanAgreementDocumentAction,
	downloadAgrementPDFAction,
	setAgreementPDFAction,
	resetAgreementPDFAction,
	setErrorAgreement,
	submitBulkFundingAction,
	successBulkFundingAction,
	setLenderAgreementPDFAction,
	downloadLenderAgrementPDFAction,
	downloadTransactionHistoryCsvAction,
	setTransactionHistoryCsvAction,
	resetTransactionHistoryCsvAction,
} from '../actions/FundingAction';

export interface IAgreementState {
	agreementBase64: Blob | undefined;
	fundingLoading: boolean;
	loanId: string;
	fundingAmount: number;
	docToken: string;
	digiSignId: string;
	signCoordinatePage: number;
	error: string;
	loanNumber: string;
	urlLoanAgreement: string;
	isSuccessBulkFunding: boolean;
	urlLenderAgreement: string;
	lenderAgreementBase64: Blob | undefined;
	transactionHistoryNumber: string | undefined;
	transactionHistoryBase64: Blob | undefined;
}

const initialState: IAgreementState = {
	fundingLoading: false,
	loanId: '',
	fundingAmount: 0,
	docToken: '',
	digiSignId: '',
	signCoordinatePage: 0,
	error: '',
	loanNumber: '',
	urlLoanAgreement: '',
	agreementBase64: undefined,
	isSuccessBulkFunding: false,
	urlLenderAgreement: '',
	lenderAgreementBase64: undefined,
	transactionHistoryNumber: undefined,
	transactionHistoryBase64: undefined
};

const fundingReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(submitFundingAction, (state, action) => ({
			...state,
			fundingLoading: true,
			loanId: action.payload.loanId,
			fundingAmount: action.payload.amount,
			loanNumber: action.payload.loanNumber,
		}))
		.addCase(generatePrivyFundingAction, (state, action) => ({
			...state,
			fundingLoading: false,
			docToken: action.payload.docToken,
			digiSignId: action.payload.digiSignId,
			signCoordinatePage: action.payload.signCoordinatePage,
		}))
		.addCase(successFundingAction, (state) => ({
			...state,
			fundingLoading: false,
			error: '',
		}))
		.addCase(failedFundingAction, (state, action) => ({
			...state,
			fundingLoading: false,
			error: action.payload.error,
		}))
		.addCase(resetFundingStateAction, (state) => ({
			...state,
			fundingLoading: false,
			loanId: '',
			fundingAmount: 0,
			loanNumber: '',
			docToken: '',
			digiSignId: '',
			signCoordinatePage: 0,
			error: '',
		}))
		.addCase(getLoanAgreementDocumentAction, (state, action) => ({
            ...state,
			fundingLoading: true,
			loanNumber: action.payload.loanNumber,
			lenderUserId: action.payload.lenderUserId,
			amount: action.payload.amount
        }))
        .addCase(setLoanAgreementDocumentAction, (state, action) => ({
            ...state,
			fundingLoading: false,
            urlLoanAgreement: action.payload.PP_filepath,
			urlLenderAgreement: action.payload.PPFP_filepath
        }))
        .addCase(resetLoanAgreementDocumentAction, (state) => ({
            ...state,
			fundingLoading: false,
            urlLoanAgreement: '',
        }))
		.addCase(downloadAgrementPDFAction, (state) => ({
			...state,
			fundingLoading: true,
		}))
		.addCase(downloadLenderAgrementPDFAction, (state) => ({
			...state,
			fundingLoading: true,
		}))
		.addCase(downloadTransactionHistoryCsvAction, (state) => ({
			...state,
		}))
		.addCase(setAgreementPDFAction, (state, action) => ({
			...state,
			fundingLoading: false,
			agreementBase64: action.payload.base64PDF
		}))
		.addCase(setLenderAgreementPDFAction, (state, action) => ({
			...state,
			fundingLoading: false,
			lenderAgreementBase64: action.payload.base64PDF
		}))
		.addCase(setTransactionHistoryCsvAction, (state, action) => ({
			...state,
			fundingLoading: false,
			transactionHistoryNumber: action.payload.transactionNumber,
			transactionHistoryBase64: action.payload.base64CSV
		}))
		.addCase(resetAgreementPDFAction, (state) => ({
			...state,
			agreementBase64: undefined,
			lenderAgreementBase64: undefined
		}))
		.addCase(resetTransactionHistoryCsvAction, (state) => ({
			...state,
			transactionHistoryBase64: undefined,
		}))
		.addCase(setErrorAgreement, (state, action) => ({
			...state,
			fundingLoading: false,
			error: action.payload
		}))
		.addCase(submitBulkFundingAction, (state) => ({
			...state,
			fundingLoading: true,
		}))
		.addCase(successBulkFundingAction, (state, action) => ({
			...state,
			fundingLoading: false,
			isSuccessBulkFunding: action.payload,
		}));
});

export default fundingReducer;
